module.exports = __webpack_public_path__ + "img/remove-badge.a40c5743.svg";